import { LazyLoader } from "@NextSkyTheme/lazy-load";

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];
    const currentProductID = productJson.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    const productJson = JSON.parse(prodData.innerHTML);
    const storedProducts = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          new LazyLoader(".image-lazy-load");
        })
        .finally(() => {})
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    this.main = document.querySelector(".main-product-section");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".block-product__buttons");
    const footer = document.querySelector("footer");
    if (!primaryBtn) return;
    var isVisible = true;
    window.addEventListener("scroll", function () {
      const buttonRect = primaryBtn.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          _this.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
          isVisible = true;
        } else {
          if (
            !isVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            isVisible = true;
            _this.classList.remove("show-sticky-cart");
            document.documentElement.classList.remove("show-sticky-cart-active");
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
            document.documentElement.classList.add("show-sticky-cart-active");
          }
        }
      } else {
        if (
          !isVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          isVisible = true;
          _this.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
        } else if (isVisible && buttonRect.bottom <= 0) {
          isVisible = false;
          _this.classList.add("show-sticky-cart");
          document.documentElement.classList.add("show-sticky-cart-active");
        }
      }
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);

const infoGallerySlide = () => {
  const gallery = document.querySelectorAll(".info-gallery__card");
  gallery.forEach((e) => {
    e.addEventListener("mouseover", (event) => {
      const currentTarget = event.currentTarget;
      if (!currentTarget.classList.contains("active")) {
        gallery.forEach((el) => {
          el.classList.remove("active");
        });
        currentTarget.classList.add("active");
      }
    });
  });
};
document.addEventListener("shopify:section:load", function () {
  infoGallerySlide();
});
infoGallerySlide();


// --- 아코디언: 하나만 열리게 만드는 스크립트 ---
function initProductAccordions(scope) {
  const root = scope || document;

  // 메인 상품 섹션 안에 있는 data-heading 가진 details만 타겟
  const accordions = root.querySelectorAll(
    ".main-product-section details[data-heading]"
  );

  if (!accordions.length) return;

  accordions.forEach((item) => {
    // 섹션 재로드 시 중복 바인딩 방지
    if (item.dataset.accordionInit === "true") return;
    item.dataset.accordionInit = "true";

    item.addEventListener("toggle", () => {
      // 닫히는 이벤트면 무시
      if (!item.open) return;

      // 나 말고 열려있는 애들 전부 닫기
      accordions.forEach((other) => {
        if (other !== item && other.open) {
          other.open = false;
        }
      });
    });
  });
}

// 페이지 처음 로드될 때
document.addEventListener("DOMContentLoaded", function () {
  initProductAccordions();
});

// Shopify 에디터에서 섹션 다시 로드될 때도 적용
document.addEventListener("shopify:section:load", function (event) {
  initProductAccordions(event.target);
});


// --- 옵션 별로 메타필드 불러오기 (이벤트 위임 버전) ---
document.addEventListener("DOMContentLoaded", function () {
  const ingredientsBox = document.querySelector("[data-ingredients-box]");
  const jsonEl = document.getElementById("VariantIngredientsJSON");
  const variantsEl = document.getElementById("ProductVariantsJSON");

  if (!ingredientsBox || !jsonEl || !variantsEl) return;

  let ingredientsMap = {};
  let variants = [];

  try {
    ingredientsMap = JSON.parse(jsonEl.textContent.trim());
    variants = JSON.parse(variantsEl.textContent.trim());
  } catch (e) {
    console.error("VariantIngredientsJSON / ProductVariantsJSON 파싱 실패", e);
    return;
  }

  const defaultHTML = ingredientsBox.innerHTML;

  // 라디오에서 옵션 라벨 텍스트 뽑는 함수
  function getLabelFromRadio(radio) {
    if (!radio) return "";
    const wrapper = radio.closest(".variant-input");
    if (!wrapper) return "";
    const labelEl = wrapper.querySelector(".option_value");
    return labelEl ? labelEl.textContent.trim() : "";
  }

  // 라벨로 variant id 찾기
  function findVariantIdByLabel(label) {
    if (!label) return null;
    const match = variants.find((v) => v.title === label || v.option1 === label);
    return match ? String(match.id) : null;
  }

  // 실제로 INGREDIENTS 박스 내용 갈아끼우기
  function updateIngredientsByLabel(label) {
    const variantId = findVariantIdByLabel(label);
    if (!variantId) {
      ingredientsBox.innerHTML = defaultHTML;
      return;
    }

    const newHtml = ingredientsMap[variantId];

    if (newHtml && newHtml.trim() !== "") {
      ingredientsBox.innerHTML = newHtml;
    } else {
      ingredientsBox.innerHTML = defaultHTML;
    }
  }

  // ✅ 1) 페이지 처음 로드 시: 체크된 옵션 기준으로 한 번 세팅
  const initiallyChecked = document.querySelector(".variant-options:checked");
  if (initiallyChecked) {
    const initialLabel = getLabelFromRadio(initiallyChecked);
    updateIngredientsByLabel(initialLabel);
  }

  // ✅ 2) 이후에는 "이벤트 위임"으로 만 처리 (DOM 갈아껴져도 계속 동작)
  document.addEventListener("change", function (event) {
    const target = event.target;
    if (!target) return;

    // 새로 렌더된 라디오까지 전부 커버
    if (target.matches(".variant-options")) {
      const label = getLabelFromRadio(target);
      updateIngredientsByLabel(label);
    }
  });
});
